// OnboardingLayout.tsx
import React from 'react'
import {Layout} from 'antd'
import classNames from 'classnames'
import {observer} from 'mobx-react'
import {IdleTimer} from 'dna-common'
import {useInjection} from 'dna-react-ioc'
import {useLocation} from 'react-router-dom'

import {useLayout} from '@/hooks'
import {IDLE_TIME_OUT_TIME} from '@/constants'
import {LayoutContent} from '@/layouts/LayoutContent'
import {UserGuideContainer, GlobalLoader} from '@/components'
import {OnboardingSider, MobileProgressBar} from '@/layouts/OnboardingLayout/components'
import {ROUTES} from '@/router/routes'
import {IGlobalLoaderStore, GlobalLoaderStoreSymbol} from '@/stores/global-loader'
import {LoadingState} from '@/types/common/LoadingState'

import {IOnboardingLayoutStore} from './IOnboardingLayoutStore'
import {MainLayoutProps} from './props'
import styles from './styles.scss'

export const OnboardingLayoutStoreSymbol = Symbol('OnboardingLayoutStore')

export const OnboardingLayout = observer(({children, theme}: MainLayoutProps) => {
    const store = useInjection<IOnboardingLayoutStore>(OnboardingLayoutStoreSymbol)
    const globalLoaderStore = useInjection<IGlobalLoaderStore>(GlobalLoaderStoreSymbol)
    const location = useLocation()

    const layoutProps = useLayout(store, store.menuItems)
    const {isMobile, isCollapsed, selectedKey, openKeys, merchant, setCollapsed, onCancelSession} =
        layoutProps

    const shouldHideSidebar = location.pathname === ROUTES.onboarding.applicationProgress

    return (
        <Layout className={classNames(styles.layout, {mobile: isMobile})}>
            <IdleTimer onCancelSession={onCancelSession} timeOut={IDLE_TIME_OUT_TIME} />
            {!shouldHideSidebar && (
                <OnboardingSider
                    isMobile={isMobile}
                    isCollapsed={isCollapsed}
                    setCollapsed={setCollapsed}
                    menuItems={[]}
                    openKeys={openKeys ?? []}
                    selectedKeys={selectedKey ? [selectedKey] : []}
                />
            )}

            <LayoutContent {...layoutProps} theme={theme} showMobileAppRedirect={false}>
                {isMobile && <MobileProgressBar />}
                {children}
            </LayoutContent>

            <UserGuideContainer />
            <GlobalLoader isLoading={globalLoaderStore.loadingState === LoadingState.LOADING} />
        </Layout>
    )
})
